import React from 'react';
import { View, ViewStyle } from 'react-native';
import SelectBox from 'LocalGluons/components/SelectBox';
import { ITextTrack, IAudioTrack } from '@24i/player-base';


type AudioTextTrackSelectBoxStyles = {
    container?: ViewStyle;
    innerContainer?: ViewStyle;
    iconClose?: ViewStyle;
    backgroundContainer?: ViewStyle;
    selectBoxStyle?: ViewStyle;
    onSelectTextTrack?: ViewStyle;
};

interface AudioTextTrackSelectBoxProps {
    defaultStyles: AudioTextTrackSelectBoxStyles;
    onSelect: (item: ITextTrack | IAudioTrack) => void;
    selectedMedia: ITextTrack[] | IAudioTrack[];
    title: string;
}

const AudioTextTrackSelectBox = ({
    defaultStyles,
    onSelect,
    selectedMedia,
    title
}: AudioTextTrackSelectBoxProps) => (
    <View style={defaultStyles.selectBoxStyle}>
        <SelectBox
            heading={title}
            onSelect={onSelect}
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            items={selectedMedia}
        />
    </View>
);

export default AudioTextTrackSelectBox;
